var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgKaddexALogo = function SvgKaddexALogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24.145,
    viewBox: "0 0 27 24.145",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-kaddex-A-logo",
    x1: 0.551,
    y1: 0.499,
    x2: 1.089,
    y2: 0.485,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076c95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-kaddex-A-logo-2",
    x1: 0.1,
    y1: -0.1,
    x2: 1.087,
    y2: 0.869,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#bc0050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#a12569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7b588b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5a84aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#3faac3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#28c9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#16e1e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0af2f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#02fcfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fffd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kaddex-kaddex-A-logo",
    transform: "translate(-6569.642 -11130.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_Down-kaddex-A-logo",
    transform: "translate(6578.27 11151.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_down-kaddex-A-logo_yellow",
    d: "M436.46,674.27a.484.484,0,0,0-.425-.27H423.278a.484.484,0,0,0-.484.484v2.275a.212.212,0,0,0,.212.212h14.8Z",
    transform: "translate(-422.794 -674)",
    fill: "url(#linear-gradient-kaddex-A-logo)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo_dx-kaddex-A-logo",
    transform: "translate(6583.131 11130.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_dx-kaddex-A-logo_blu",
    d: "M541.381,239l11.769,23.833a.212.212,0,0,1-.185.3H549.8l-9.275-18.652",
    transform: "translate(-539.657 -239)",
    fill: "#00fffd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Logo_dx-kaddex-A-logo_gradient",
    d: "M524.26,239l3.5,7.078-1.783,3.578-3.4-6.838a.487.487,0,0,1,0-.424Z",
    transform: "translate(-522.537 -239)",
    fill: "url(#linear-gradient-kaddex-A-logo-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo_sx-kaddex-A-logo",
    transform: "translate(6569.642 11130.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Logo_sx-kaddex-A-logo_pink",
    d: "M257.371,239.3a.484.484,0,0,1,.424-.267H261l-.028.055-1.751,3.513-10.175,20.424a.212.212,0,0,1-.185.115h-2.594a.484.484,0,0,1-.424-.7Z",
    transform: "translate(-245.792 -239.03)",
    fill: "#ff00b9"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKaddexALogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Kaddex_A_logo.c5d0f810.svg";
export { ForwardRef as ReactComponent };